export const fetchData = async (url) => {
    try {
      const response = await fetch(url);
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json(); // Parse JSON response
      return data;
    } catch (error) {
      console.error("Fetch Error:", error);
      return null; // Return null in case of an error
    }
  };
  
